import Vue from 'vue'
import Vuex from 'vuex'
import cart from './modules/cart'
import lang from './modules/lang'
import programme from './modules/programme'
import studentProgramme from './modules/student-programme'
import login from './modules/login'
import system from './modules/system'
import getters from './getters'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
const store = new Vuex.Store({
    modules: {
       cart,
       lang,
       login,
       system,
       programme,
       studentProgramme,
    },
    getters,
    plugins: [createPersistedState({ storage: window.sessionStorage })]
})

export default store